module.exports = __webpack_public_path__ + "static/media/propaganda7.40e25a01.png";